/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_ScoringInputs */

const en_directory_hubs_signals_geo_scoring = /** @type {(inputs: Directory_Hubs_Signals_Geo_ScoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five dimensions, 20 points each, summed to 100. Each dimension runs a fixed checklist of automated checks (pass / warn / fail). Passed checks earn full weight, warnings earn partial weight, and failures earn zero — so the score moves as the page's machine-readiness improves.`)
};

const zh_directory_hubs_signals_geo_scoring = /** @type {(inputs: Directory_Hubs_Signals_Geo_ScoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`五个维度，各 20 分，合计 100。每个维度运行固定的自动化检查项（通过/警告/失败）：通过得满分权重，警告得部分权重，失败得零分——因此分数会随页面的机器可读性提升而变化。`)
};

/**
* | output |
* | --- |
* | "Five dimensions, 20 points each, summed to 100. Each dimension runs a fixed checklist of automated checks (pass / warn / fail). Passed checks earn full weigh..." |
*
* @param {Directory_Hubs_Signals_Geo_ScoringInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_scoring = /** @type {((inputs?: Directory_Hubs_Signals_Geo_ScoringInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_ScoringInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_scoring(inputs)
	return zh_directory_hubs_signals_geo_scoring(inputs)
});
export { directory_hubs_signals_geo_scoring as "directory.hubs.signals.geo.scoring" }